import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchStandaloneMode =
  createAction(actionTypes.FETCH_STANDALONE_MODE_REQUEST);
export const fetchStandaloneModeSuccess =
  createAction(actionTypes.FETCH_STANDALONE_MODE_SUCCESS);
export const fetchStandaloneModeFailure =
  createAction(actionTypes.FETCH_STANDALONE_MODE_FAILURE);

export const updateStandaloneMode =
  createAction(actionTypes.UPDATE_STANDALONE_MODE_REQUEST);
export const updateStandaloneModeSuccess =
  createAction(actionTypes.UPDATE_STANDALONE_MODE_SUCCESS);
export const updateStandaloneModeFailure =
  createAction(actionTypes.UPDATE_STANDALONE_MODE_FAILURE);
